import React from "react";
import { Star, Heart, Sparkles } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const UniqueExperienceSection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="section bg-gray-50 overflow-hidden">
      <div className="container-custom">
        {/* O zi trăită ca altădată */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-romanian-red font-semibold text-sm uppercase tracking-wider">
              {t.experience.uniqueExperience}
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-romanian-blue mt-2 mb-6">
              {t.experience.dayLikeOld}
            </h2>
            <div className="space-y-4 text-gray-600">
              <p className="flex items-start space-x-3">
                <Sparkles className="w-5 h-5 text-romanian-yellow flex-shrink-0 mt-1" />
                <span>{t.experience.desc1}</span>
              </p>
              <p className="flex items-start space-x-3">
                <Heart className="w-5 h-5 text-romanian-red flex-shrink-0 mt-1" />
                <span>{t.experience.desc2}</span>
              </p>
              <p className="flex items-start space-x-3">
                <Star className="w-5 h-5 text-romanian-blue flex-shrink-0 mt-1" />
                <span>{t.experience.desc3}</span>
              </p>
            </div>
            <div className="mt-8 p-6 bg-romanian-yellow/10 rounded-xl border-l-4 border-romanian-yellow">
              <p className="text-gray-700 italic">{t.experience.quote}</p>
              <p className="mt-4 font-semibold text-romanian-blue">
                {t.experience.noHurry}
              </p>
            </div>
          </div>
          <div className="order-1 lg:order-2 relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/traditional.png"
                alt="Festival atmosphere"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-romanian-red rounded-xl flex items-center justify-center shadow-lg">
              <Heart className="w-12 h-12 text-white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueExperienceSection;
